import React from 'react';
import { motion } from 'framer-motion';

interface FlyerPreviewProps {
  imageUrl: string;
  alt?: string;
  className?: string;
}

const FlyerPreview: React.FC<FlyerPreviewProps> = ({ 
  imageUrl, 
  alt = 'Campaign Flyer',
  className = '' 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
      className={`flex items-center justify-center ${className}`}
    >
      <div className="relative max-w-md w-full  overflow-hidden shadow-2xl">
        <img
          src={imageUrl}
          alt={alt}
          className="w-full h-auto object-contain"
        />
      </div>
    </motion.div>
  );
};

export default FlyerPreview;
